import {
    createStore
} from 'vuex'
import authModule from './modules/auth'
import userModule from './modules/user'
import appModule from './modules/app'

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth: authModule,
        user: userModule,
        app: appModule
    }
})